import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AreaAdmin, ConversaUsaurio } from '../../models/area';
import { AreaAdminLocalProvider } from '../../providers/area-admin-local/area-admin-local';
import { Subscription } from 'rxjs';
import { NavProxyProvider } from '../../providers/nav-proxy/nav-proxy';
import { ConversaAreaUsuarioPage } from '../conversa-area-usuario/conversa-area-usuario';

@IonicPage()
@Component({
  selector: 'page-lista-conversa-usuario',
  templateUrl: 'lista-conversa-usuario.html',
})
export class ListaConversaUsuarioPage {

  public areaAdmin: AreaAdmin;
  private subs: Subscription;
  public conversaSelecionada: ConversaUsaurio;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private areaAdminLocalProvider: AreaAdminLocalProvider,
    private changeDetectorRef: ChangeDetectorRef,
    private navProxyProvider: NavProxyProvider) {
    this.areaAdmin = this.navParams.get('areaAdmin');
    this.subs = new Subscription();
    this.ordenarLista();
    const sub = this.areaAdminLocalProvider.$areas.skip(1).subscribe(
      (areas) => {
        const area = areas.find(a => a.idArea === this.areaAdmin.idArea);
        if (area) { 
          this.areaAdmin = area;
          this.ordenarLista();
          this.changeDetectorRef.detectChanges();
        } else {
          this.navCtrl.popToRoot();
        }
      }
    );
    const subConteudo = this.navProxyProvider.conteudo.subscribe(
      conteudo => {
        if (conteudo && conteudo.pagina === ConversaAreaUsuarioPage) {
          if (this.conversaSelecionada && this.conversaSelecionada.idUsuario !== conteudo.params.conversaUsuario.idUsuario) {
            this.conversaSelecionada = conteudo.params.conversaUsuario;
          }
        }
      }
    )
    this.subs.add(sub);
    this.subs.add(subConteudo);
  }

  ngOnChanges() {
    this.ordenarLista();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.areaAdminLocalProvider.removerConversaContatoAcimaDoLimite(this.areaAdmin.idArea);
  }

  private ordenarLista() {
    this.areaAdmin.conversasUsuarios = this.areaAdmin.conversasUsuarios.sort(
      (a, b) => {
        let timeA = 0;
        let timeB = 0;
        if (a.mensagens && a.mensagens.length > 0) {
          timeA = a.mensagens[a.mensagens.length - 1].dataHora
        }
        if (b.mensagens && b.mensagens.length > 0) {
          timeB = b.mensagens[b.mensagens.length - 1].dataHora
        }
        return timeB - timeA
      }
    );
  }

  public selecionarConversa(conversa: any) {
    this.conversaSelecionada = conversa;
  }

  public trackByFunction(index: number, item: ConversaUsaurio) {
    if (!item.mensagens || item.mensagens.length < 1) {
      return null;
    }
    const ultimaMensagem = item.mensagens[item.mensagens.length - 1];
    return `${ultimaMensagem.idEnvio}:${ultimaMensagem.statusMensagemLida}:${ultimaMensagem.statusMensagemRecebida}:${index}`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/lista-conversa-usuario/lista-conversa-usuario.ts